import z from "zod/v4";

import {
  AiNodeContextSchema,
  ConversationAction,
  InputRequirementSchema,
  WorkflowIdList,
} from "../../../schemas/ai";

export const StartWorkflowRequestBodyDtoSchema = z.object({
  workflowId: z.string(),
  sessionId: z.uuid(),
  version: z.string().optional(),
  initialContext: AiNodeContextSchema.partial(),
  cacheKey: z.string().optional(),
});

export type StartWorkflowRequestBodyDto = z.infer<
  typeof StartWorkflowRequestBodyDtoSchema
>;

export const StartWorkflowResponseDtoSchema = z.object({
  sessionId: z.string(),
  workflowId: z.string(),
  status: z.string(),
  nextAction: InputRequirementSchema.optional(),
  error: z.any(),
  variables: z.record(z.string(), z.any()),
  messages: z
    .object({
      nodeId: z.string(),
      message: z.any(),
    })
    .array()

    .optional(),
});

export type StartWorkflowResponseBodyDto = z.infer<
  typeof StartWorkflowResponseDtoSchema
>;
